import { Type } from '@angular/core';
import { environment } from '@environments/environments';
import { BraintreeBankAccountDrawerComponent } from '@shared/components/page-layout/drawers/braintree-bank-account-drawer/braintree-bank-account-drawer.component';
import { JpMorganBankAccountDrawerComponent } from '@shared/components/page-layout/drawers/jpmorgan-bank-account-drawer/jpmorgan-bank-account-drawer.component';
import { LayoutDrawerComponent } from '@shared/components/page-layout/drawers/layout-drawer.component';

export const CustomBankAccountDrawerComponent: Type<LayoutDrawerComponent> =
    environment.useJpMorganCreditCardDrawer
        ? JpMorganBankAccountDrawerComponent
        : BraintreeBankAccountDrawerComponent;
